import React, { useRef, useLayoutEffect } from "react";
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";
import { useReactToPrint } from "react-to-print";
import QRPrintModal from "../../../../components/QRPrintModal/QRPrintModal";
import { useAppStore } from "../../../../store";
import { selectCurrentUserRecord } from "../../../../store/common/userRecord/slice";
import "./style.css";

const EmptyState = () => {
  const toast = React.useRef(null);
  const menu = React.useRef(null);
  const contentRef = useRef();

  const userRecord = useAppStore(selectCurrentUserRecord);

  const shopName = userRecord?.shopName || userRecord?.displayName;
  // Replace spaces with hyphens but keep original capitalization and text for better SEO visibility
  const urlBusinessName = shopName ? shopName.replace(/\s+/g, "-") : "";
  const chatUrl = userRecord?.uid
    ? `${window.location.origin}/${urlBusinessName}`
    : null;

  const handlePrint = useReactToPrint({ contentRef });

  const handleShare = async (platform) => {
    if (!chatUrl) return;

    const shareText = shopName
      ? `Chat with ${shopName} directly!`
      : "Chat with me directly!";
    const encodedUrl = encodeURIComponent(chatUrl);
    const encodedText = encodeURIComponent(shareText);

    const shareUrls = {
      whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
      telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
    };

    if (platform === "copy") {
      navigator.clipboard.writeText(chatUrl);
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Chat link copied to clipboard!",
        life: 3000,
      });
      return;
    }

    if (platform === "print") {
      handlePrint();
      return;
    }

    window.open(shareUrls[platform], "_blank");
  };

  const shareItems = [
    {
      label: "Copy Link",
      icon: "pi pi-copy",
      command: () => handleShare("copy"),
    },
    {
      label: "Print QR Code",
      icon: "pi pi-print",
      command: () => handleShare("print"),
    },
    // {
    //   label: 'WhatsApp',
    //   icon: 'pi pi-whatsapp',
    //   command: () => handleShare('whatsapp')
    // },
    // {
    //   label: 'Facebook',
    //   icon: 'pi pi-facebook',
    //   command: () => handleShare('facebook')
    // },
    // {
    //   label: 'Twitter',
    //   icon: 'pi pi-twitter',
    //   command: () => handleShare('twitter')
    // },
    // {
    //   label: 'Telegram',
    //   icon: 'pi pi-telegram',
    //   command: () => handleShare('telegram')
    // }
  ];

  const header = (
    <div className="flex align-items-center gap-2 justify-content-center p-4">
      <i className="pi pi-qrcode text-2xl text-primary-500"></i>
      <span className="text-xl font-bold brand-name">
        {process.env.REACT_APP_BRAND_NAME}
      </span>
    </div>
  );

  const footer = (
    <div className="flex justify-content-center p-4">
      <Menu ref={menu} popup model={shareItems} className="share-menu" />
    </div>
  );

  return (
    <div className="flex justify-content-center align-items-center min-h-screen p-4">
      <Toast ref={toast} />
      <QRPrintModal
        shopName={shopName}
        chatUrl={chatUrl}
        userRecord={userRecord}
      />
    </div>
  );
};

export default EmptyState;
